import { Container, makeStyles } from "@material-ui/core";

import PageTitle from "src/components/PageTitle";

import CampaignDefaults from "./CampaignDefaults";
import Messaging from "./Messaging";
import SubaccountSettings from "./SubaccountSettings";

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(4)
  }
}));

export default function Settings(): JSX.Element {
  const classes = useStyles();

  return (
    <Container>
      <PageTitle title="Settings" />
      <div className={classes.section}>
        <SubaccountSettings />
      </div>
      <div className={classes.section}>
        <CampaignDefaults />
      </div>
      <div className={classes.section}>
        <Messaging />
      </div>
    </Container>
  );
}
